import { Injectable, EventEmitter } from '@angular/core';

export interface MenuItem
{
    name: string;
    route: string;
}

@Injectable()
export class NavBarService
{
    public menuClick = new EventEmitter<MenuItem>();
    public showBasket = false;

    public constructor()
    {

    }

    public navbarClicked(item: MenuItem): void
    {
        this.menuClick.emit(item);
    }

    public showBasketFlag(showBasket: boolean): void
    {
        this.showBasket = showBasket;
    }
}

